// import { isOverseasVersion } from 'common-module/src/util';

// eslint-disable-next-line
export const messageCateGorys = ['comment', 'responsible', 'follow', 'automation_station_msg', 'sys'];

export function getMessageCategory(){
  // eslint-disable-next-line
  return messageCateGorys.map(key => {
    return {
      key,
      label: this.$t(`message.category.${key}`)
    };
  });
}

export const KanBanWidgetType = 'KanBanWidget';
export const SCENE_GUIDE = 6;

// 是否为生产环境
// eslint-disable-next-line
export const isProd = window.$config.VUE_APP_ENV === 'prod';

export const isPre = window.$config.VUE_APP_ENV === 'pre';
export const systemUpdateKey = 'zk-systemUpdateKey';
